import React, { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NoteEditor from '@components/TimelineNote/Editor';
import { currentlyEditingNoteSelector, updateCurrentlyEditingNote } from '@actions/notes';
import Occasion from '@support/Occasion';

interface CurrentlyEditableTimelineNoteProps {
  onBlur?: () => void;
  ignoreOutsideClicks?: boolean;
  finishEditing?: () => void;
  isNewNote?: boolean;
  reminderEditorOpen?: boolean;
  setReminderEditorOpen?: Dispatch<boolean>;
}

export default function FocusedTimelineNote(props: CurrentlyEditableTimelineNoteProps) {
  const dispatch = useDispatch();
  const note = useSelector(currentlyEditingNoteSelector);

  let noteDismissable = note && !note.isPersisted && !note.isFetching && note.content.length == 0;
  if (props.isNewNote && note?.isEmpty) {
    noteDismissable = true;
  }

  const handleNoteContentChange = (content: string) => {
    if (content != note.content) {
      dispatch(updateCurrentlyEditingNote(note.copyWith({ content })));
    }
  };

  const handleNoteReminderChange = (date: Occasion | null) => {
    if (date?.toString() != note.reminder?.date.toString()) {
      const existingReminder = note.reminder;
      const reminder = existingReminder ? { ...existingReminder, date } : { date };
      const newNote = note.copyWith({ reminder });
      dispatch(updateCurrentlyEditingNote(newNote));
    }
  };

  if (!note) {
    return null;
  }

  return (
    <NoteEditor
      note={note}
      onNoteContentChange={handleNoteContentChange}
      onNoteReminderChange={handleNoteReminderChange}
      finishEditing={props.finishEditing || props.onBlur}
      canSave={!noteDismissable}
      ignoreOutsideClicks={props.ignoreOutsideClicks}
      reminderEditorOpen={props.reminderEditorOpen}
      setReminderEditorOpen={props.setReminderEditorOpen}
    />
  );
}
